var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('JoinRegionModal'),_vm._v(" "),_c('LanguageChooserModal'),_vm._v(" "),_c('SearchBarModal'),_vm._v(" "),_c('StyleGuideModal')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }